<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table [data]="data" class="full" (itemClick)="openDetail($event)" matSort>
      <div *elderTableToolbar class="layout-row place-around-center flex-none">
        <elder-search-box
          class="flex-90"
          [dense]="true"
          [autoPanel]="true"
          [elderSearchContext]="data?.filter"
          [forcedFilters]="forcedFilters()"
          queryKey="query"
        >
        </elder-search-box>
      </div>

      <!-- icon column -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%" mat-sort-header></th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            <mat-icon [color]="getColor(job.state)">{{ getIcon(job.state) }}</mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="spec">
        <th mat-header-cell *matHeaderCellDef style="width: 5%" mat-sort-header>
          {{ 'jobs.spec' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            <span class="text-body-small">{{ job.spec.domain }}</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="specDetails">
        <th mat-header-cell *matHeaderCellDef style="width: 25%">
          {{ 'jobs.specType' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            <app-job-spec-view [spec]="job.spec"> </app-job-spec-view>
          }
        </td>
      </ng-container>

      <!-- createdAt column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.createdAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar" class="text-body-small">
          @if (coerceJob(jobVar); as job) {
            <span class="text-body-small">{{
              job.audit?.createdAt | date: 'dd.MM.yyyy HH:mm:ss'
            }}</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef style="width: 5%" mat-sort-header>
          {{ 'context.priority' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            <app-job-priority-indicator [priority]="job.priority"></app-job-priority-indicator>
          }
        </td>
      </ng-container>

      <!-- startedAt column -->
      <ng-container matColumnDef="startedAt">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'jobs.started' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar" class="text-body-small">
          @if (coerceJob(jobVar); as job) {
            <span class="text-body-small">{{ job.startedAt | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
          }
        </td>
      </ng-container>

      <!-- duration column -->
      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef style="width: 5%">
          {{ 'jobs.duration' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            {{ job.duration | isoDuration }}
          }
        </td>
      </ng-container>

      <!-- progressPercent column -->
      <ng-container matColumnDef="progressPercent">
        <th mat-header-cell *matHeaderCellDef style="width: 5%" elderNumberCell>
          {{ 'jobs.progress' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar" elderNumberCell>
          @if (coerceJob(jobVar); as job) {
            {{ formatProgress(job.result?.progressPercent) }}
          }
        </td>
      </ng-container>

      <!-- status column -->
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'jobs.state' | translate }}
        </th>
        <td mat-cell *matCellDef="let jobVar">
          @if (coerceJob(jobVar); as job) {
            <mat-progress-spinner
              [matTooltip]="job.state"
              [color]="getColor(job.state)"
              [strokeWidth]="3"
              [diameter]="24"
              [value]="100"
              [mode]="
                job.state === JobState.RUNNING || job.state === JobState.AWAITING_SUBTASKS
                  ? 'indeterminate'
                  : 'determinate'
              "
            >
            </mat-progress-spinner>
          }
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
